import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { formatTitle } from "@/lib/typography";

interface GlossaireProps {
  entries: Array<{ term: string; definition: string }>;
}

export const Glossaire = ({ entries }: GlossaireProps) => {
  return (
    <Card className="mt-6">
      <CardHeader>
        <CardTitle className="text-base">{formatTitle("Glossaire")}</CardTitle>
      </CardHeader>
      <CardContent>
        <dl className="space-y-2">
          {entries.map((entry, i) => (
            <div key={i} className="text-sm">
              <dt className="font-semibold text-primary inline">{entry.term}</dt>
              <dd className="inline ml-2 text-muted-foreground">{entry.definition}</dd>
            </div>
          ))}
        </dl>
      </CardContent>
    </Card>
  );
};
